import Action from 'redux/helpers/createAction'
const name = 'domainTags'

export const addDomainTag = Action(name + '/ADD_DOMAIN_TAG', (domainId, params) => ({
  data: {
    domainId,
    payload: params
  }
}))

export const addDomainTagSuccess = Action(name + '/ADD_DOMAIN_TAG_SUCCESS', (domainId, data) => ({
  domainId,
  data
}))

export const updateDomainTag = Action(
  name + '/UPDATE_DOMAIN_TAG_DATA',
  (domainId, tagId, payload, filters) => ({
    data: {
      domainId,
      tagId,
      payload,
      filters
    }
  })
)

export const updateDomainTagSuccess = Action(name + '/UPDATE_DOMAIN_TAG_DATA_SUCCESS')

export const removeDomainTag = Action(name + '/REMOVE_DOMAIN_TAG', (domainId, tagId) => ({
  data: {
    domainId,
    tagId
  }
}))

export const removeDomainTagSuccess = Action(name + '/REMOVE_DOMAIN_TAG_SUCCESS')

export const addTagsToKeywords = Action(
  name + '/ADD_TAGS_TO_KEYWORDS',
  (domainId, params, filters, refreshKeywords = true) => ({
    data: {
      domainId,
      payload: params,
      filters,
      refreshKeywords
    }
  })
)

export const addTagsToKeywordsSuccess = Action(name + '/ADD_TAGS_TO_KEYWORDS_SUCCESS')

export const deleteTagsFromKeywords = Action(
  name + '/DELETE_TAGS_FROM_KEYWORDS',
  (domainId, params, filters, refreshKeywords = true) => ({
    data: {
      domainId,
      payload: params,
      filters,
      refreshKeywords
    }
  })
)

export const deleteTagsFromKeywordsSuccess = Action(name + '/DELETE_TAGS_FROM_KEYWORDS_SUCCESS')
